import React, { useEffect, useRef } from "react";
import "./styles.scss";
import { getInsight } from "../../../../utils";

const Index = (props) => {
  // const location = useLocation();
  // const [advertisement, setAdvertisement] = useState(false);

  // useEffect(() => {
  //   const adContainer = document.getElementById("ad-container-news-r-top");

  //   if (adContainer) {
  //     adContainer.innerHTML = ""; // Clear previous ad
  //   }

  //   // Remove any previously injected ad script
  //   const oldScript = document.getElementById("ad-script");
  //   if (oldScript) {
  //     oldScript.remove();
  //   }

  //   // Fetch and inject script
  //   const fetchAndInjectScript = async () => {
  //     try {
  //       const response = await getAdvertisementByPlacement(
  //         "inner",
  //         "right",
  //         "1"
  //       );

  //       // const response = await axios.get(
  //       //   "http://127.0.0.1:8000/api/v1/ad.js?placement=inner&ad_space=header&count=1"
  //       // );

  //       const originalScript = response.data;

  //       // Check if the script is valid
  //       if (!originalScript) {
  //         console.error("Invalid script content");
  //         adContainer.innerHTML = " Advertisement with us";
  //         setAdvertisement(false);
  //         return;
  //       }

  //       // Patch the script to append to #ad-container-news-r-top instead of document.body
  //       const patchedScript = originalScript.replace(
  //         /document\.body\.insertBefore\(([^,]+),\s*document\.body\.firstChild\)/,
  //         "document.getElementById('ad-container-news-r-top').appendChild($1)"
  //       );

  //       const script = document.createElement("script");
  //       script.id = "ad-script";
  //       script.type = "text/javascript";
  //       script.text = patchedScript;

  //       adContainer?.appendChild(script);
  //       setAdvertisement(true);
  //       console.log("Ad script injected!");
  //     } catch (error) {
  //       setAdvertisement(false);
  //       console.error("Failed to load ad script:", error);
  //     }
  //   };

  //   fetchAndInjectScript();
  // }, [location]); // Re-run if the route changes

  // return (
  //   <>
  //     <div className={`right-ad ${advertisement ? "active" : ""}`}>
  //       {advertisement ? (
  //         <div id="ad-container-news-r-top" />
  //       ) : (
  //         "Advertisement with us"
  //       )}
  //     </div>
  //   </>
  // );

  const adUrl = process.env.REACT_APP_NEWS_RIGHT_SIDE_TOP_ADV;

  const iframeRef = useRef(null);

  useEffect(() => {
    let isMounted = true; // To prevent setting state or calling refs if unmounted
    let insight_id = null;

    const setup = async () => {
      try {
        const insight = await getInsight();

        if (isMounted && insight && insight.insight_id) {
          insight_id = insight.insight_id;

          const iframe = iframeRef.current;
          const sendInsight = () => {
            if (iframe?.contentWindow) {
              iframe.contentWindow.postMessage(
                { insight_id },
                process.env.REACT_APP_NEWS_RIGHT_SIDE_TOP_ADV
              );
            }
          };

          // Add listener only after insight is confirmed
          iframe?.addEventListener("load", sendInsight);

          // Cleanup
          return () => {
            iframe?.removeEventListener("load", sendInsight);
          };
        }
      } catch (err) {
        console.warn("Failed to get insight", err);
      }
    };

    setup();

    return () => {
      isMounted = false;
    };
  }, [adUrl]);

  if (!adUrl) {
    return <div className="top-ad">Ad URL not configured.</div>;
  }
  return (
    <div className="right-ad active">
      <iframe
        ref={iframeRef}
        title="Advertisement"
        src={adUrl}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          display: "block",
        }}
        loading="lazy"
        sandbox="allow-scripts allow-same-origin allow-popups" // Optional
      />
    </div>
  );
};

export default Index;
